import { FileStatus } from '../../core/models/file-status.model';

export interface FileDetails {
  id: number;
  requestId: number;
  fileName: string;
  fileStatusId: number;
  fileStatusName: string;
  totalDocuments: number;
}

export interface FileDetailsState {
  file: FileDetails | null;
  statuses: FileStatus[];
  isLoading: boolean;
  isUpdating: boolean;
  isLoadingStatuses: boolean;
  error: string | null;
}

export const initialState: FileDetailsState = {
  file: null,
  statuses: [],
  isLoading: false,
  isUpdating: false,
  isLoadingStatuses: false,
  error: null,
};
